import { STATUS_FAIL, STATUS_FETCH, STATUS_REQUEST, STATUS_GROUP } from "../store/config";

const statusInit = {
	data: [],
	error: null,
	isFetching: false
}

const status = (state = statusInit, action) => {
	switch(action.type) {
		case STATUS_REQUEST:
			return {
				...state,
				isFetching: action.isFetching,
				timestamp: action.timestamp
			}
		case STATUS_FETCH:
			return {
				...state,
				isFetching: action.isFetching,
				data: action.payload,
				timestamp: action.timestamp
			}
		case STATUS_GROUP:
			return {
				...state,
				isFetching: action.isFetching,
				data: action.payload,
				timestamp: action.timestamp
			}
		case STATUS_FAIL:
			return {
				...state,
				isFetching: action.isFetching,
				error: action.error,
				timestamp: action.timestamp
			}
		default:
			return {
				...state
			}
	}
}

export default status;


// WEBPACK FOOTER //
// ./src/reducers/status.js